export enum RmItemTypeEnum{
    FABRIC = 'FABRIC',
    TIRM = 'TRIM'
}